import { Card } from '@delmonicos/shared-design-system-react/src/components/card/card';
import { NumberFixed } from '@delmonicos/shared-design-system-react/src/components/number-fixed/number-fixed';
import { GapEnum } from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import {
  Text,
  TextColor,
  TextFontSize,
} from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { AccentTitle } from '@delmonicos/shared-design-system-react/src/components/typography/title/accent-title/accent-title';
import classNames from 'classnames';
import { endOfMonth, formatISO, startOfMonth, subMonths } from 'date-fns';
import { useTranslation } from 'react-i18next';

import {
  useCpmsBoGetTransactionReportsCountForecastQuery,
  useCpmsBoGetTransactionReportsCountQuery,
} from '@service/cpms-bo-transaction-reports-count-statistics.service';

import * as css from '../statistics.module.scss';

export const TransactionsCard = (): React.JSX.Element => {
  const { t } = useTranslation();

  const { data: previousMonthData } = useCpmsBoGetTransactionReportsCountQuery({
    transactionEndedAtAfter: formatISO(startOfMonth(subMonths(new Date(), 1))),
    transactionEndedAtBefore: formatISO(endOfMonth(subMonths(new Date(), 1))),
  });

  const { data: currentMonthData } = useCpmsBoGetTransactionReportsCountQuery({
    transactionEndedAtAfter: formatISO(startOfMonth(new Date())),
    transactionEndedAtBefore: formatISO(endOfMonth(new Date())),
  });

  const { data: forecastedData } =
    useCpmsBoGetTransactionReportsCountForecastQuery({});

  return (
    <Card gap={GapEnum.M}>
      <AccentTitle
        icon="electric-car-2"
        text={t('$.dashboard.statistics.transactions.title')}
      />
      <div className={classNames(css.transactions, css.previousMonth)}>
        <NumberFixed
          bold
          color={TextColor.Primary}
          fontSize={TextFontSize.Inherit}
          number={previousMonthData?.total ?? 0}
          digits={0}
        />
        <Text>{t('$.dashboard.statistics.transactions.unit')}</Text>
      </div>
      <div className={classNames(css.transactions, css.currentMonth)}>
        <NumberFixed
          bold
          color={TextColor.Primary}
          fontSize={TextFontSize.Inherit}
          number={currentMonthData?.total ?? 0}
          digits={0}
        />
        <Text>{t('$.dashboard.statistics.transactions.unit')}</Text>
      </div>
      <div className={classNames(css.forecasted)}>
        <NumberFixed
          bold
          fontSize={TextFontSize.Inherit}
          number={forecastedData?.total ?? 0}
          digits={0}
        />
        <Text>{t('$.dashboard.statistics.transactions.unit')}</Text>
      </div>
    </Card>
  );
};
